<template>
  <div class="flex flex-wrap">
    <EbayBulkCategorySelector v-if="ebayBulk" @closed="ebayBulk = false" />
    <button class="btn-dark-button mt-20 mx-auto" @click="ebayBulk = true">
      Ebay Assign categories in bulk
    </button>
    <!-- <button class="btn-dark-button mt-20 mx-auto" @click="amazonBulk = true">
      Amazon Assign categories in bulk
    </button> -->
  </div>
</template>
<script>
import EbayBulkCategorySelector from "@/components/EbayBulkCategorySelector.vue";
export default {
  name: "MarketplacesCategoryManager",
  components: {
    EbayBulkCategorySelector
  },
  data() {
    return {
      amazonBulk: false,
      ebayBulk: false
    };
  }
};
</script>
